import React from 'react';

import classes from './SillyTable.module.css';

const SillyTable = props => {
    return (
        <div className={classes.SillyTable}>
            <div className={classes.mainMessage}>
                <span className={classes.mainCopy}>
                    You Shall Not Pass!
                </span>
            </div>
            <div className={classes.imageWrapper}>
                <img src="/assets/images/wizardImageFlat.svg" alt="Silly Wizard" />
            </div>
            <div className={classes.subMessage}>
                <span className={classes.subCopy}>
                    (until you finish the Equipment configuration)
                </span>
            </div>
        </div>
    );
};

export default SillyTable;
